import { Component, OnInit } from '@angular/core';
import { CuestionarioService } from '../../_services/cuestionario.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Cuestionario } from '../../_models/cuestionario';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CuestionarioPreguntaRespuestaService } from '../../_services/cuestionario-pregunta-respuesta.service';
import { CuestionarioPreguntaRespuesta } from '../../_models/cuestionario-pregunta-respuesta';

@Component( {
  selector: 'app-cuestionarios-editar',
  templateUrl: 'cuestionarios-editar.component.html'
} )

export class CuestionariosEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  cuestionario: Cuestionario;
  lisCuestionarios: Cuestionario[] = [];
  tabSeleccionado = 'INFO';
  formulario: FormGroup;
  submitted = false;

  constructor( private cueServicio: CuestionarioService,
               private nav: NavService,
               private conServicio: ConfirmationService,
               private route: ActivatedRoute,
               private router: Router,
               private cuePreguntasRespuestaServicio: CuestionarioPreguntaRespuestaService,
               private fb: FormBuilder ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.cueServicio.obtener( params[ 'id' ] ).subscribe( cuestionario => {
          this.cuestionario = cuestionario;
          const tabSeleccionado = this.nav.getTab();
          if ( tabSeleccionado === 'PREGUNTAS' ) {
            this.tabSeleccionado = tabSeleccionado;
            this.nav.setTab( null );
          }
          this.carServicios();
        } );
      } else {
        this.carServicios();
      }
    } );
  }

  carServicios() {
    this.formulario = this.fb.group( {
      idCuestionario: [ this.cuestionario ? this.cuestionario.idCuestionario : null ],
      codigo: [ this.cuestionario ? this.cuestionario.codigo : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      nombre: [ this.cuestionario ? this.cuestionario.nombre : null, [ Validators.required, Validators.maxLength( 100 ) ] ],
      descripcion: [ this.cuestionario ? this.cuestionario.descripcion : null, [ Validators.required, Validators.maxLength( 500 ) ] ],
      numeroPreguntas: [ this.cuestionario ? this.cuestionario.numeroPreguntas : null, [ Validators.maxLength( 9 ) ] ],
      valorPonderacion: [ this.cuestionario ? this.cuestionario.valorPonderacion : null, (this.cuestionario && this.cuestionario.indicadorPonderacion) ? [ Validators.required, Validators.maxLength( 5 ) ] : Validators.maxLength( 5 ) ],
      indicadorAzar: [ this.cuestionario ? this.cuestionario.indicadorAzar : false ],
      indicadorPonderacion: [ this.cuestionario ? this.cuestionario.indicadorPonderacion : false ],
      indicadorOrdenado: [ this.cuestionario ? this.cuestionario.indicadorOrdenado : false ],
      indicadorHabilitado: [ this.cuestionario ? this.cuestionario.indicadorHabilitado : true ],
      indicadorSarlaft4: [ this.cuestionario ? this.cuestionario.indicadorSarlaft4 : true ]
    } );

    this.cueServicio.listado().subscribe( cuestionarios => {
      this.lisCuestionarios = cuestionarios;
      this.carInformacionInicial = false;
    } );
  }

  actualizarCuestionario( cuestionario: Cuestionario ) {
    this.cueServicio.actualizar( cuestionario ).subscribe( rta => {
      this.cuestionario = cuestionario;
      this.nav.setMesage( 2 );
      this.guardando = false;
      this.tabSeleccionado = 'PREGUNTAS';
    }, error => {
      this.nav.setMesage( 3 );
      this.guardando = false;
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      const cuestionario = this.formulario.value;
      if ( cuestionario.idCuestionario ) {
        if ( this.cuestionario.indicadorAzar !== cuestionario.indicadorAzar && cuestionario.indicadorAzar ) {
          this.cuePreguntasRespuestaServicio.listadoPorCuestionario( cuestionario.idCuestionario ).subscribe( lisPreguntas => {
            const respuestas = [];
            lisPreguntas.map( ( s: CuestionarioPreguntaRespuesta ) => {
              if ( s.indicadorHabilitado && (s.idPreguntaDepende !== '' && s.idPreguntaDepende !== null && s.idPreguntaDepende !== undefined) ) {
                s.idPreguntaDepende = null;
                respuestas.push( s );
              }
            } );
            if ( respuestas.length > 0 ) {
              this.conServicio.confirm( {
                message: this.nav.buscarMensaje( 'CUESTIONARIO.MSG_GUARDARAZAR' ),
                header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
                icon: 'fa fa-question-circle',
                key: 'cuestionario',
                accept: () => {
                  this.cuePreguntasRespuestaServicio.bulk( respuestas ).subscribe( actRespuestas => {
                    this.actualizarCuestionario( cuestionario );
                  } );
                },
                reject: () => {
                  this.guardando = false;
                }
              } );
            } else {
              this.actualizarCuestionario( cuestionario );
            }
          } );
        } else {
          this.actualizarCuestionario( cuestionario );
        }

      } else {
        this.cueServicio.agregar( cuestionario ).subscribe( rta => {
          this.cuestionario = cuestionario;
          this.cuestionario.idCuestionario = rta.idCuestionario;
          this.f.idCuestionario.setValue( rta.idCuestionario );
          this.nav.setMesage( 1 );
          this.guardando = false;
          this.tabSeleccionado = 'PREGUNTAS';
        }, error => {
          this.nav.setMesage( 3 );
          this.guardando = false;
        } );
      }
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'cuestionario',
        accept: () => {
          this.router.navigate(['apl/cuestionarios']);
        },
        reject: () => {
        }
      } );
    } else {
      this.router.navigate(['apl/cuestionarios']);
    }
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'PREGUNTAS';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }

  validarCodigo() {
    this.codExiste = this.lisCuestionarios.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  cambioAprobacion( checked: boolean ) {
    this.f.valorPonderacion.clearValidators();
    if ( checked ) {
      this.f.valorPonderacion.setValidators( [ Validators.required, Validators.maxLength( 5 ) ] );
    } else {
      this.f.valorPonderacion.setValue( null );
      this.f.valorPonderacion.setValidators( [ Validators.maxLength( 5 ) ] );
    }
  }

  cambioAzar( checked: boolean ) {
    if ( !checked ) {
      this.f.numeroPreguntas.setValue( null );
    }
  }

  cambiarOrdenado( ordenado: boolean ) {
    this.f.indicadorOrdenado.setValue( ordenado );
  }
}
